// @flow

import React, { PureComponent } from 'react';

import type { RencontreArticleType } from 'types/Rencontre';
import { dynamicClassName } from 'utils/dynamicClassName';
import { getCompetitionTag } from 'utils/graphResponseUtils';
import { formatDateWithAbbvStr, getHourAndMinutesStr, getDateFromString } from 'utils/dateUtils';
import { usePlaceholderOnImageError } from 'utils/assetsUtils';

type Props = {
  match: RencontreArticleType,
  isBig?: boolean,
  upcomingMatch?: boolean,
  isOver?: boolean,
  isDark?: boolean,
};

export default class CompetitionCard extends PureComponent<Props> {
  static defaultProps = {
    isBig: false,
    upcomingMatch: false,
    isDark: false,
    isOver: false,
  };

  render() {
    const {
      match: {
        competition,
        localStructure,
        visiteurStructure,
        etat,
        journee,
        pointsStructureLocale,
        pointsStructureVisiteur,
        dateEffective,
      },
      isBig,
      upcomingMatch,
      isDark,
      isOver,
    } = this.props;

    const nom = competition && competition.nom ? competition.nom : '';
    const cardWrapperClasses = dynamicClassName('box card card--score');

    isBig && cardWrapperClasses.add('is--big');
    isDark && cardWrapperClasses.add('is--dark');
    upcomingMatch && cardWrapperClasses.add('upcoming');
    isOver && cardWrapperClasses.add('over');
    const label = (etat === 'Planifiée') ? 'À venir' : 'Terminée';
    const matchJoue = label === 'Terminée';

    return (
      <div className={cardWrapperClasses.build()}>
        <div className='card__header'>
          <div>
            <span className='ft-h6 ft-up'>{getCompetitionTag(competition)}</span>
            <span className='ft-h6'>{`${nom} — ${journee}`}</span>
          </div>
          <span className='ft-h6 ft-up label'>{label}</span>
        </div>
        <div className='card__body'>
          <div className='match'>
            <div className='match__club'>
              <p className={(matchJoue && pointsStructureLocale > pointsStructureVisiteur) ? 'ft-h3 ft-700' : 'ft-h3 ft-400'}>
                <span>{localStructure.nom}</span>
                <img
                  src={localStructure.embleme}
                  alt={`Logo ${localStructure.nom}`}
                  style={{ width: '24', height: '24' }}
                  onError={(e) => usePlaceholderOnImageError(e.target, '/img/logo/placeholder-club.png')} />
              </p>
            </div>
            {matchJoue &&
              <div className="match__info">
                <p className="match__score">
                  <span className={(pointsStructureLocale > pointsStructureVisiteur) ? "ft-700" : ''}>
                    {pointsStructureLocale}
                  </span>
                  <span className="match__colon">–</span>
                  <span className={(pointsStructureVisiteur > pointsStructureLocale) ? "ft-700" : ''}>
                    {pointsStructureVisiteur}
                  </span>
                </p>
              </div>
            }
            {!matchJoue &&
            <div className='match__info'>
              <p className='match__time ft-700 ft-up'>
                {formatDateWithAbbvStr(getDateFromString(dateEffective))}
                <br />
                {getHourAndMinutesStr(getDateFromString(dateEffective))}
              </p>
            </div>}
            <div className='match__club'>
              <p className={(matchJoue && pointsStructureVisiteur > pointsStructureLocale) ? 'ft-h3 ft-700' : 'ft-h3 ft-400'}>
                <span>{visiteurStructure.nom}</span>
                <img
                  src={visiteurStructure.embleme}
                  alt={`Logo ${visiteurStructure.nom}`}
                  style={{ width: '24', height: '24' }}
                  onError={(e) => usePlaceholderOnImageError(e.target, '/img/logo/placeholder-club.png')} />
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
